import { formatINR } from "@/lib/format";

export function DematSection({ demat }) {
  if (!demat) return null;
  return (
    <section>
      <div className="flex items-end justify-between border-b border-[#D8D4C7] pb-4 mb-6">
        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Portfolio</div>
          <h3 className="font-serif text-3xl tracking-tight">Demat performance.</h3>
        </div>
        <div className="text-right">
          <div className={`font-serif text-3xl num ${demat.total_pl >= 0 ? "text-[#2E6F40]" : "text-[#D94F3D]"}`} data-testid="demat-total-pl">
            {demat.total_pl >= 0 ? "+" : ""}{formatINR(demat.total_pl)}
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#6C7565] mt-1">
            Invested {formatINR(demat.total_invested, { compact: true })} · Value {formatINR(demat.total_value, { compact: true })} · {demat.total_pl_pct}%
          </div>
        </div>
      </div>

      <div className="border border-[#D8D4C7] bg-white overflow-x-auto">
        <table className="w-full text-sm" data-testid="demat-holdings-table">
          <thead>
            <tr className="border-b border-[#1A1F16] text-left">
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565]">Symbol</th>
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565]">Account</th>
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565] text-right">Qty</th>
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565] text-right">Avg</th>
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565] text-right">LTP</th>
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565] text-right">Value</th>
              <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-[#6C7565] text-right">P/L</th>
            </tr>
          </thead>
          <tbody>
            {demat.holdings.length === 0 ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-[#6C7565]">No holdings yet.</td></tr>
            ) : demat.holdings.map((h) => (
              <tr key={`${h.account}-${h.symbol}`} className="border-b border-[#EAE7DD]">
                <td className="px-4 py-3 font-mono font-medium">{h.symbol}</td>
                <td className="px-4 py-3 text-[#6C7565]">{h.account}</td>
                <td className="px-4 py-3 text-right num">{h.quantity}</td>
                <td className="px-4 py-3 text-right num">{formatINR(h.avg_price, { decimals: 2 })}</td>
                <td className="px-4 py-3 text-right num">{formatINR(h.current_price, { decimals: 2 })}</td>
                <td className="px-4 py-3 text-right num">{formatINR(h.value, { decimals: 2 })}</td>
                <td className={`px-4 py-3 text-right num ${h.pl >= 0 ? "text-[#2E6F40]" : "text-[#D94F3D]"}`}>
                  {h.pl >= 0 ? "+" : ""}{formatINR(h.pl, { decimals: 2 })}
                  <div className="text-[10px] font-mono">{h.pl_pct}%</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
